import type { EmailTemplate } from 'lib/api'

export const MULTILINGUAL_EMAIL_TEMPLATE_TYPES = new Set([
  'rejection',
  'screening',
  'interview_invitation',
  'interview_completion',
])

export type EmailTemplateLanguage = 'fr' | 'en'

export function getEmailTemplateDisplayLanguage(i18nLanguage: string): EmailTemplateLanguage {
  if (i18nLanguage === 'fr' || i18nLanguage?.startsWith('fr')) {
    return 'fr'
  }
  return 'en'
}

export function getEmailTemplateDisplayName(
  template: EmailTemplate,
  _displayLanguage: EmailTemplateLanguage,
  t: any
): string {
  if (MULTILINGUAL_EMAIL_TEMPLATE_TYPES.has(template.template_type)) {
    return template.name
  }

  return t(
    `settings.emailTemplatesPage.templateTypes.${template.template_type}`,
    template.name
  )
}

export function filterEmailTemplatesForDisplay(
  templates: EmailTemplate[],
  displayLanguage: EmailTemplateLanguage
): EmailTemplate[] {
  return templates.filter((template) => (template.language || 'fr') === displayLanguage)
}

export function isFixedFrenchInterviewInvitation(template: {
  template_type?: string
  language?: string
}): boolean {
  const language = template.language || 'fr'
  return template.template_type === 'interview_invitation' && (language === 'fr' || language === 'en')
}

export function getDefaultTemplateLanguage(
  templateType: string,
  displayLanguage: EmailTemplateLanguage
): EmailTemplateLanguage {
  return MULTILINGUAL_EMAIL_TEMPLATE_TYPES.has(templateType) ? displayLanguage : 'fr'
}
